//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getPropertyIcon } from '../../Card/cardConfigurations.js'
import { getHasValueValidateFn } from '../bussinessProcessObjectValidation.js'

import CardSectionProperties from '../../Card/CardSectionProperties.vue'
import WarningBanner from '../../WarningBanner.vue'
import FilesGroupsContainer from '../../File/FilesGroupsContainer'

function getAddressAdditionalObjectTypes (request) {
  const assignedBrigade = request.brigades.find(b => b.assigned) || null
  if (assignedBrigade && assignedBrigade.brigadeId) {
    return [
      { key: 'request', name: `Заявка бригады ${assignedBrigade.brigadeName}`, url: `/service/delta/brigade/queueRequestsAddresses?id=${assignedBrigade.brigadeId}` }
    ]
  } else {
    return []
  }
}

export default {
  name: 'BussinessProcessEventsForm',
  components: {
    WarningBanner,
    CardSectionProperties
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    initConfig: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      actionType: null,
      event: null,
      forms: null,
      btnOkName: null,
      btnOkHidden: false,
      btnOkDisabled: true,
      title: null,
      warnings: null,
      warningFormat: null,
      callback: null,
      edit: false,
      delete: false,
      readonly: false,

      config: {},
      objectSrc: {},

      loading: false
    }
  },
  computed: {
    isError: function () {
      return this.actionType === 'error'
    }
  },
  created: function () {
    const initConfig = this.initConfig
    this.actionType = initConfig.actionType || null
    this.event = initConfig.event || null
    this.forms = initConfig.forms
    this.btnOkName = initConfig.btnOkName
    this.btnOkHidden = !!initConfig.btnOkHidden
    this.title = initConfig.title
    this.warnings = initConfig.warnings
    this.warningFormat = initConfig.warningFormat
    this.callback = initConfig.callback
    this.edit = initConfig.edit || false
    this.delete = initConfig.delete || false
    this.readonly = initConfig.readonly || false

    this.init()
  },
  methods: {
    init: function () {
      this.objectSrc = {}
      this.config = {
        props: []
      }

      const checkFilesDuplicates = true
      Object.defineProperty(this.objectSrc, '_filesGroups', {
        value: new FilesGroupsContainer({
          checkDuplicates: checkFilesDuplicates
        }),
        writable: true,
        enumerable: false,
        configurable: true
      })

      const updateFormPropertiesFunctions = []
      this.forms.forEach(form => {
        const formId = form.type
        const formContent = typeof form === 'string' ? {} : form.content

        const eventProperties = form.eventProperties

        const propertiesConfigurations = form.propertiesConfigurations || []
        const defaultContent = form.defaultContent || {}

        if (eventProperties) {
          Object.keys(eventProperties).forEach(propKey => {
            const property = eventProperties[propKey]
            if (property instanceof Function) {
              if (propKey === 'updateProperties') {
                updateFormPropertiesFunctions.push(property)
              }
              return
            }

            if (!this.edit && property.computed) {
              return
            }

            const propertyConfiguration = propertiesConfigurations.find(o => o.name === propKey) || {}
            let defaultValue = property.value || null
            if (this.edit || this.delete) {
              defaultValue = formContent[propKey]
            } else {
              if (property.getDefaultValueFn) {
                defaultValue = property.getDefaultValueFn()
              } else if (defaultContent && defaultContent[propKey] != null) {
                defaultValue = defaultContent[propKey]
              }
            }

            const uniqueKey = propKey + '_' + formId
            this.$set(this.objectSrc, uniqueKey, defaultValue)

            const prop = Object.assign({}, property)

            prop.key = uniqueKey
            prop.code = propKey
            prop.eventId = formId

            const name = property.label || property.name
            prop.name = name
            prop._nameUpperCase = name.toUpperCase()
            prop._hidden = !!propertyConfiguration.hidden

            const validationProperty = propertyConfiguration.validation || {
              readonly: true,
              required: false
            }
            if (this.edit) {
              prop.editable = !validationProperty.readonly
            } else {
              prop.editable = !validationProperty.readonly && !this.delete
            }
            prop.required = validationProperty.required
            prop.requiredFn = function () {
              return this.required
            }
            prop.validateFn = getHasValueValidateFn(prop.type, prop.subType)
            // prop.additionalValidateFn используется внутри компонентов

            // Иконка
            if (!prop._icon) {
              const icon = getPropertyIcon(prop)
              if (icon) {
                prop._icon = icon
              }
            }

            if (prop.type === 'documents') {
              const filesGroupsContainer = this.objectSrc._filesGroups
              prop.validateFn = getHasValueValidateFn(prop.type, prop.subType, () => filesGroupsContainer.getFilesGroup(prop.key).hasFiles())

              prop.addOnly = !!validationProperty.addOnly
              prop.componentProps.readonly = validationProperty.readonly || !!this.delete

              const objectId = this.record.request.id
              prop.componentProps.filesGroupKey = uniqueKey
              prop.componentProps.objectValueSource = !!(this.edit || this.delete || defaultValue != null)
              prop.componentProps.highlightErrors = checkFilesDuplicates
              prop.componentProps.calculateHash = checkFilesDuplicates
              prop.componentProps.sourceConfig = {
                preloadFormId: objectId + '_' + uniqueKey + (this.event && this.event.id != null ? ('_' + this.event.id) : ''),
                uploadURL: '/service/delta/document/upload',
                removeDelayed: true,
                removeExternal: true
              }
              prop.componentProps.handlers = {
                add: (fileWrapper) => {
                  filesGroupsContainer.onFileAddToUpload(fileWrapper, this)
                },
                'remove-from-upload': function (fileWrapper) {
                  console.log('onFileRemoveFromUpload')
                  filesGroupsContainer.onFileRemoveFromUpload(fileWrapper, this)
                }
              }
            } else if (prop.type === 'address') {
              prop.componentProps.additionalObjectTypes = getAddressAdditionalObjectTypes(this.record.request)
              const addressValue = this.objectSrc[prop.key]
              if (addressValue != null && !addressValue.value && addressValue.name) {
                addressValue.value = addressValue.name
              }
            } else if (prop.type === 'brigade') {
              prop.shortOnly = validationProperty.shortOnly
              prop.componentProps.options = prop.options
            }

            Object.defineProperty(prop, '_objectSrc', {
              value: this.objectSrc,
              writable: true,
              enumerable: false,
              configurable: true
            })
            Object.defineProperty(prop, '_config', {
              value: this.config,
              writable: true,
              enumerable: false,
              configurable: true
            })

            this.config.props.push(prop)
          })
        }
      })

      this.config.updateProperties = function (object) {
        for (const updatePropertiesFn of updateFormPropertiesFunctions) {
          updatePropertiesFn.call(this, object)
        }
      }
      this.config.updateProperties(this.objectSrc)

      this.btnOkDisabled = this.edit && this.readonly
    },
    onApply: async function () {
      try {
        this.loading = true
        await this.validateFields()
        const result = await this.getFormResult()
        const applyResult = await this.callback(result)
        this.$emit('applied', applyResult)
      } catch (e) {
        // console.error(e)
        this.$emit('error', e)
      } finally {
        this.loading = false
      }
    },
    validateFields: function () {
      // TODO: проверить валидацию внутри CardField (не по кнопке, а not lazy)

      const validFieldLabels = []
      this.config.props.forEach(prop => {
        const value = this.objectSrc[prop.key]
        if (!prop.validateFn(value)) {
          validFieldLabels.push(prop.name)
        }
      })

      if (validFieldLabels.length === 0) {
        return Promise.resolve('Обязательные поля заполнены')
      } else {
        let message = ''
        if (validFieldLabels.length > 0) {
          message += 'Не заполнены обязательные поля: ' + validFieldLabels.map(val => '"' + val + '"').join(', ') + '.\n'
        }

        this.$q.notify({
          type: 'negative',
          message: message,
          progress: true,
          timeout: 10000
        })
        return Promise.reject(Error('Не заполнены обязательные поля'))
      }
    },
    getFormResult: async function () {
      const filesGroupsContainer = this.objectSrc._filesGroups
      if (filesGroupsContainer.hasChanges()) {
        await filesGroupsContainer.saveFilesChanges({
          notify: true,
          target: this
        })
      }
      const result = {}
      Object.keys(this.objectSrc).forEach(objectSrcKey => {
        const objectSrcProp = this.config.props.find(prop => prop.key === objectSrcKey)
        if (result[objectSrcProp.eventId] == null) {
          result[objectSrcProp.eventId] = {}
        }

        let value
        if (objectSrcProp.type === 'documents') {
          const filesGroup = filesGroupsContainer.getFilesGroup(objectSrcKey)
          value = filesGroup.files.map(fileWrapper => fileWrapper.id)
        } else {
          value = this.objectSrc[objectSrcKey]

          if (objectSrcProp.type === 'object') {
            value = value ? value.id : null
          } else if (objectSrcProp.type === 'brigade') {
            if (value && value.id && value.workDate && value.workShift) {
              const workShift = value.workShift && value.workShift.key ? value.workShift.key : value.workShift
              value = { id: value.id, workDate: value.workDate, workShift: workShift }
            } else {
              value = null
            }
          }
        }

        result[objectSrcProp.eventId][objectSrcProp.code] = value
      })
      return result
    },
    onCancel: function () {
      this.forms = null
      this.$emit('cancel')
    }
  }
}

